import { chartLabels, platformIcons, TABLE_COLUMN_TYPE } from "../../../../constants"
import { SummaryBalance, TableColumn, TrackPlaylist } from "../../../../types"
import { KSpan } from "kahuna-base-react-components"
import { lang } from "../../../../constants/languages"
import React from "react"
import { formatNumber, getCurrency, yyyymmToDateLocale } from "../../../../utility"

const balanceColumns: TableColumn[] = [
  {
    header: lang.royalties.balance.columns.dsp,
    headerStyle: {
      textAlign: "left",
      minWidth: "120px",
      width: "24%"
    },
    overrideHeader: () => (
      <KSpan text={lang.royalties.balance.columns.dsp} color="#111" fontWeight={500} fontSize={14} />
    ),
    type: TABLE_COLUMN_TYPE.FUNCTION,
    render: (row: SummaryBalance) => {
      return (
        <div className="flex gap-1 items-center">
          {platformIcons[row.dsp] && <img width={24} src={platformIcons[row.dsp]} />}
          <KSpan text={chartLabels.platform[row.dsp] || row.dsp} fontWeight={row.dsp === "TOTAL" ? 700 : 400} />
        </div>
      )
    }
  },
  {
    header: lang.royalties.balance.columns.activityPeriod,
    headerStyle: {
      textAlign: "left",
      minWidth: "120px",
      width: "18%"
    },
    overrideHeader: () => (
      <KSpan text={lang.royalties.balance.columns.activityPeriod} color="#111" fontWeight={500} fontSize={14} />
    ),
    type: TABLE_COLUMN_TYPE.FUNCTION,
    render: (row: SummaryBalance) => {
      return (
        <div>
          <KSpan text={yyyymmToDateLocale(row.activityPeriod, { month: "short", year: "numeric" })} />
        </div>
      )
    }
  },
  {
    header: lang.royalties.balance.columns.reportingPeriod,
    headerStyle: {
      textAlign: "left",
      minWidth: "120px",
      width: "18%"
    },
    overrideHeader: () => (
      <KSpan text={lang.royalties.balance.columns.reportingPeriod} color="#111" fontWeight={500} fontSize={14} />
    ),
    type: TABLE_COLUMN_TYPE.FUNCTION,
    render: (row: SummaryBalance) => {
      return (
        <div>
          <KSpan text={yyyymmToDateLocale(row.reportingPeriod, { month: "short", year: "numeric" })} />
        </div>
      )
    }
  },
  {
    header: lang.royalties.balance.columns.quantity,
    headerStyle: {
      textAlign: "left",
      minWidth: "120px",
      width: "20%"
    },
    overrideHeader: () => (
      <KSpan text={lang.royalties.balance.columns.quantity} color="#111" fontWeight={500} fontSize={14} />
    ),
    type: TABLE_COLUMN_TYPE.FUNCTION,
    render: (row: SummaryBalance) => {
      return (
        <div>
          <KSpan text={row.quantity.toLocaleString()} fontWeight={row.dsp === "TOTAL" ? 600 : 400} />
        </div>
      )
    }
  },
  {
    header: lang.royalties.balance.columns.totalNet,
    headerStyle: {
      textAlign: "left",
      minWidth: "120px",
      width: "20%"
    },
    overrideHeader: () => (
      <KSpan text={lang.royalties.balance.columns.totalNet} color="#111" fontWeight={500} fontSize={14} />
    ),
    type: TABLE_COLUMN_TYPE.FUNCTION,
    render: (row: SummaryBalance) => {
      const totalNet = row.totalNet.toLocaleString("en-EN", { minimumFractionDigits: 2, maximumFractionDigits: 2 })
      const currency = getCurrency(row.currency)
      return (
        <div>
          <KSpan text={`${currency}${totalNet}`} fontWeight={row.dsp === "TOTAL" ? 600 : 400} />
        </div>
      )
    }
  }
]

export default balanceColumns
